module.exports = __webpack_public_path__ + "static/media/alan.5f64179b.jpg";